import React from 'react'
import { Controller } from 'react-hook-form'
import { FormFeedback, Input, Label } from 'reactstrap'
import Select from 'react-select'

const InputSelect = ({
  label,
  control,
  errors,
  onChange,
  options
}) => {
  return (
    <React.Fragment>
      <Label className="form-label" for={options.id}>
        {label}
      </Label>
      <Controller
        control={control}
        id={options.id}
        name={options.name}
        render={({ field }) => (
          <Select
            {...field}
            isMulti={options.isMulti}
            placeholder={options.placeholder || ''}
            isDisabled={options.isDisabled}
            invalid={errors[options.name] && true}
            value={field.value}
            options={options.options}
            onChange={(value) => {
              field.onChange(value)
              if (onChange) {
                onChange(value)
              }
            }}
          />
        )}
      />
      {errors[options.name] && (
        <FormFeedback>{errors[options.name].message}</FormFeedback>
      )}
    </React.Fragment>
  )
}

export default InputSelect